var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-screen-70 flex"},[_c('div',{staticClass:"text-gray-800 text-2xl m-auto text-center"},[_vm._v(" 404 | Not Found ")])])}]

export { render, staticRenderFns }